import React, { memo } from 'react'

import { Button, Card, Checkbox, Divider, Form, Input, Space } from 'antd'
import {
  UserOutlined,
  LockOutlined,
  GithubOutlined,
  TwitterOutlined,
  WechatOutlined,
  AlipayCircleOutlined,
  QqOutlined
} from '@ant-design/icons'

import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { menus } from '@/service/login'
import { AppDispatch } from '@/store'
import { accountLoginThunk } from '@/store/modules/login'

import { FormWrapper } from './css'
import login_left from '@/assets/images/lushair_product.jpeg'
import login_lushair from '@/assets/images/lushair.jpg'
import qrcode from '@/assets/images/qrcode.png'

const iconStyle = { fontSize: 22 }

// 语言配置 - 只需要修改这个变量即可切换语言
const IS_CN_VERSION = true // true: 中文版本, false: 英文版本

const contentConfig = {
  cn: {
    title: 'Lushair-您的AI护发助手',
    image: login_left, // 中文版本使用 login_left
    tutorial: { text: '产品使用说明', url: 'http://xhslink.com/o/2vcyCk4DoI8' },
    android: { text: '下载Android客户端', url: 'https://sj.qq.com/appdetail/com.joyhonest.jh_camera' },
    ios: { text: '下载iOS客户端', url: 'https://apps.apple.com/de/app/lushair/id6447665246' },
    group: { text: '加入养发用户群', url: 'https://work.weixin.qq.com/apph5/external_room/join/group_mng?plg_id=a77fdd7b5f59acab51f03db2f660b1df&' },
    wx: { text: '查看养发知识', url: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg4ODY4NjIxMQ==&scene=124#wechat_redirect' },
    about: { text: '关于我们', url: 'https://www.lushair.cn' },
    tips: 'Tips: 如果点击按钮时没有响应，请在浏览器中打开网页',
    showWxButton: true
  },
  en: {
    title: 'Lushair-Your AI hair care assistant',
    image: login_lushair, // 英文版本使用 login_lushair
    tutorial: { text: 'Tutorial', url: 'https://watch.wave.video/oCOUa6vus29QPe9o' },
    android: { text: 'For Android', url: 'https://play.google.com/store/apps/details?id=com.lushair.jh_camera' },
    ios: { text: 'For iPhone', url: 'https://apps.apple.com/cn/app/lushair-hair-care-assistant/id6499344143' },
    group: { text: 'Join Group', url: 'https://t.me/genpulseai' },
    wx: { text: '查看养发知识', url: 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg4ODY4NjIxMQ==&scene=124#wechat_redirect' },
    about: { text: 'About Us', url: 'https://www.lushair.ai' },
    tips: 'Tips: If there is no response when clicking the button, please open it in your browser',
    showWxButton: false
  }
}

const currentContent = IS_CN_VERSION ? contentConfig.cn : contentConfig.en

const LoginForm = memo(() => {
  const [form] = Form.useForm()
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()

  const onAndroidFinish = (values: any) => {
    console.log('Finish:', values)
    window.location.href = currentContent.android.url
  }

  const onIOSFinish = (values: any) => {
    console.log('Finish:', values)
    window.location.href = currentContent.ios.url
  }

  const onAboutFinish = (values: any) => {
    console.log('Finish:', values)
    window.location.href = currentContent.about.url
  }

  const onTutorialFinish = (values: any) => {
    window.location.href = currentContent.tutorial.url
  }

  const onGroupFinish = (values: any) => {
    window.location.href = currentContent.group.url
  }

  const onWxFinish = (values: any) => {
    window.location.href = currentContent.wx.url
  }

  return (
    <FormWrapper>
      <Card bodyStyle={{ padding: '24px 44px' }}>
        <h2 className="title">{currentContent.title}</h2>
        <div className="left">
          <img className="img" src={currentContent.image} alt="img" />
        </div>

        <div className="form">
          <Form form={form} name="horizontal_login" onClick={onTutorialFinish}>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="tutorial-button">
                {currentContent.tutorial.text}
              </Button>
            </Form.Item>
          </Form>
        </div>

        <Form className="form" form={form} name="horizontal_login" onClick={onAndroidFinish}>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="android-button">
              {currentContent.android.text}
            </Button>
          </Form.Item>
        </Form>

        <Form className="form" form={form} name="horizontal_login" onClick={onIOSFinish}>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="iOS-button">
              {currentContent.ios.text}
            </Button>
          </Form.Item>
        </Form>

        <Form className="form" form={form} name="horizontal_login" onClick={onGroupFinish}>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="group-button">
              {currentContent.group.text}
            </Button>
          </Form.Item>
        </Form>

        {currentContent.showWxButton && (
          <Form className="form" form={form} name="horizontal_login" onClick={onWxFinish}>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="wx-button">
                {currentContent.wx.text}
              </Button>
            </Form.Item>
          </Form>
        )}

        <Form className="form" form={form} name="horizontal_login" onClick={onAboutFinish}>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="about-button">
              {currentContent.about.text}
            </Button>
          </Form.Item>
        </Form>

        <div className="left">
          <h4 className="tips">{currentContent.tips}</h4>
        </div>

      </Card>
    </FormWrapper>
  )
})

export default LoginForm
